"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
/* eslint-disable eqeqeq */
const conditionalBuilder = () => ({ entryVars: { a, b, operator }, functionId, callbacks, executeProcesses, }) => {
    const condition = () => {
        switch (operator) {
            case '==':
                return a == b;
            case '===':
                return a === b;
            case '!=':
                return a != b;
            case '!==':
                return a !== b;
            case '<':
                return (0, getNumberFromUnknown_1.default)(a) < (0, getNumberFromUnknown_1.default)(b);
            case '<=':
                return (0, getNumberFromUnknown_1.default)(a) <= (0, getNumberFromUnknown_1.default)(b);
            case '>':
                return (0, getNumberFromUnknown_1.default)(a) > (0, getNumberFromUnknown_1.default)(b);
            case '>=':
                return (0, getNumberFromUnknown_1.default)(a) >= (0, getNumberFromUnknown_1.default)(b);
            default:
                return false;
        }
    };
    try {
        const result = condition();
        const callback = result ? callbacks.successProcess : callbacks.errorProcess;
        executeProcesses(functionId, callback, result);
        return result;
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, `${error}`);
        return undefined;
    }
};
exports.default = conditionalBuilder;
